var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "budicon-chat-information"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-22A1.5 1.5 0 0 0 0 1.5v16A1.5 1.5 0 0 0 1.5 19h12.663a.508.508 0 0 1 .306.1l4.926 3.7A1 1 0 0 0 21 22v-3h2.5a1.5 1.5 0 0 0 1.5-1.5v-16A1.5 1.5 0 0 0 23.5 0zm.5 17.5a.5.5 0 0 1-.5.5h-2.8a.7.7 0 0 0-.7.7V22l-4.926-3.691a1.51 1.51 0 0 0-.911-.309H1.5a.5.5 0 0 1-.5-.5v-16a.5.5 0 0 1 .5-.5h22a.5.5 0 0 1 .5.5z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.002h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.002h1v2h-1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatInformation);
export default __webpack_public_path__ + "static/media/Chat-Information.896d4413a43514c59100142ab061c9e4.svg";
export { ForwardRef as ReactComponent };